export default __webpack_public_path__ + "static/media/Marianne-Medium_Italic.a79009c7.woff";